import React, { useState } from 'react';
import axios from 'axios';
import './Dictionary.css'; // Import your CSS file

const apiKey = 'a4b7b8d7f03040d792o0ft5d941a335f';

const Dictionary = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [wordData, setWordData] = useState({});
  const [imageResults, setImageResults] = useState([]);

  const handleSearch = async () => {
    try {
      const response = await axios.get(
        `https://api.shecodes.io/dictionary/v1/define?word=${searchTerm}&key=${apiKey}`
      );
      const data = response.data;
      setWordData(data);

      // Fetch images based on the search term
      const imagesResponse = await axios.get(
        `https://api.shecodes.io/images/v1/search?query=${searchTerm}&key=${apiKey}`
      );
      const imagesData = imagesResponse.data;
      setImageResults(imagesData.photos);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  return (
    <div className="dictionary-container">
      <div className="search-section">
        <input
          type="text"
          placeholder="Enter a word"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <button onClick={handleSearch}>Search</button>
      </div>

      {wordData.word && (
        <div className="word-definition-section">
          <h2>{wordData.word}</h2>
          <p>Phonetics: {wordData.phonetic}</p>
          <div className="meanings-container">
            {wordData.meanings.map((meaning, index) => (
              <div className="meaning" key={index}>
                <h3>{meaning.partOfSpeech}</h3>
                <p>{meaning.definition}</p>
                {meaning.synonyms && (
                  <div className="synonyms">
                    <strong>Synonyms:</strong> {meaning.synonyms.join(', ')}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      )}

      {imageResults.length > 0 && (
        <div className="image-section">
          <h2>Images</h2>
          <div className="image-container">
            {imageResults.map((image, index) => (
              <div className="image-card" key={index}>
                <img src={image.src.landscape} alt="Illustration" />
                <a href={image.url} target="_blank" rel="noopener noreferrer">
                  Photo by {image.photographer}
                </a>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default Dictionary;
